import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    record: undefined, // 当前展示的detail,
    mintData: []        // NFT mint data
  },
  mutations: {
    setRecord:(state, data) => {
      state.record = data
    },
    setMintData:(state, data) => {
      state.mintData = data
    }
  },
  getters: {
    getRecord: (state) => {
      return state.record
    },
    getMintData: (state) => {
      return state.mintData
    }
  },
  actions: {
    setRecord: ({commit}, data) => {
			commit('setRecord', data)
		},
    setMintData: ({commit}, data) => {
			commit('setMintData', data)
		}
  }
})
